import 'css/src/components/public-pages/sections/EnterpriseTextSection';

import React from 'react';

import { BUTTON_SIZES, PrimaryButton } from '../../common/ui/Button';

const EnterpriseTextSection = React.memo(function EnterpriseTextSection() {
    return (
        <div className="p-l5-16 p-l5-sm-48 section-2 pb-l5-48 enterprise-text-section">
            <div className="container">
                <div className="row align-items-center mt-l5-48">
                    <div className="col-md-6">
                        <h2>Set up for success with professional services</h2>
                        <p className="font-l5 font-l5--regular my-l5-16 px-l5-0 w-75">
                            Even the best tools need the right team behind them. Our Professional
                            Services experts partner with you to shape strategy, elevate
                            storytelling, and scale production. With experience across 200+ B2B
                            brands, we help you get more from Lumen5 and more from every piece of
                            content.
                        </p>
                        <PrimaryButton
                            size={BUTTON_SIZES.LG}
                            text="Explore ProServe"
                            href="https://ps.lumen5.com/"
                            className="mt-l5-16"
                        />
                    </div>
                    <div className="col-md-6">
                        <img
                            src="https://storage.googleapis.com/lumen5-site-images/2025-website-assets/enterprise/proserve.webp"
                            className="m-l5-48 enterprise-text-section-image"
                            loading="lazy"
                            decoding="async"
                            alt="Professional Services"
                        />
                    </div>
                </div>
                <div className="row align-items-center mt-l5-48">
                    <div className="col-md-6">
                        <img
                            src="https://storage.googleapis.com/lumen5-site-images/2025-website-assets/enterprise/privacy.webp"
                            className="m-l5-48 enterprise-text-section-image"
                            loading="lazy"
                            decoding="async"
                            alt="Privacy and Security"
                        />
                    </div>
                    <div className="col-md-6">
                        <h2>
                            Built for privacy,
                            <br />
                            ready for scale
                        </h2>
                        <p className="font-l5 font-l5--regular my-l5-16 px-l5-0 w-75">
                            Lumen5 meets enterprise standards in security, compliance, and AI
                            governance. With 7+ years of experience working alongside legal and
                            privacy teams, we offer the controls your business needs and the trust
                            your stakeholders expect.
                        </p>
                        <PrimaryButton
                            size={BUTTON_SIZES.LG}
                            text="Request a demo"
                            href="https://lumen5.com/book-a-demo?utm_campaign=6880892-%5BMARKETING%5D%20Demo%20Request%20Form&utm_source=Website&utm_medium=enterprise_request_a_demo"
                            className="mt-l5-16"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
});

export default EnterpriseTextSection;
